[
  { "id": "seve", "name": "Sève", "description": "Invocations : +25 % de PV et de durée.", "summonPct": 25, "maxStacks": 3, "classes": ["sadida"] }
]
